module.exports = __webpack_public_path__ + "static/media/login-bg@2x.9032e215.png";